import requestAction from '../../utils/requestAction'
import { PreorderDetailInput } from '../../models/PreorderDetail';

export const upsertPreorderDetail = (preorderDetail: PreorderDetailInput, handleResponse?: () => void) =>
  requestAction('PREORDER_DETAIL_UPSERT')(
    `preorderDetails${(preorderDetail as PreorderDetailInput).id ? `/${(preorderDetail as PreorderDetailInput).id}` : ''}`,
    (preorderDetail as PreorderDetailInput).id ? 'PUT' : 'POST',
    preorderDetail,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse() })

export const upsertBulkPreorderDetail = (preorderDetail: PreorderDetailInput[], handleResponse: () => void) =>
  requestAction('PREORDER_BULK_DETAIL_UPSERT')(
    'preorderBulkDetails',
    'POST',
    preorderDetail,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse() })

export const updatePriceBulkPreorderDetail = (preorderDetail: PreorderDetailInput[], handleResponse?: () => void) =>
  requestAction('PREORDER_BULK_DETAIL_UPDATE_PRICE')(
    `preorderBulkUpdatePrice`,
    'POST',
    preorderDetail,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse() })
